/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:38:29
 * @Description: file content
 */ 
import React, { Component } from 'react';
//import OriginBreadcrumb from 'bee-breadcrumb';
import { Breadcrumb as OriginBreadcrumb } from "@tinper/next-ui";

//import './index.less';
//require('bee-breadcrumb/build/Breadcrumb.css');

class Breadcrumb extends Component {
	render() {
		let classToPass = 'base-breadcrumb';
		const { className } = this.props;
		if (className) {
			classToPass += ' ' + className;
		}
		return <OriginBreadcrumb {...this.props} className={classToPass} />;
	}
}

class BreadcrumbItem extends Component {
	render() {
		return <OriginBreadcrumb.Item {...this.props} />;
	}
}

Breadcrumb.BreadcrumbItem = BreadcrumbItem;
export default Breadcrumb;
